export default "<div [ngStyle]=\"{'visibility': (uiState$ |async)  ? 'hidden' : 'visible'}\" class=\"overlay\"></div>";